import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import { createUploadLink } from 'apollo-upload-client';
import Observable from 'zen-observable';

ApolloLink.Observable = Observable;

Vue.use(VueApollo);

const request = async (operation) => {
  const token = localStorage.getItem('default_auth_token') || localStorage.getItem('default_auth_token_ttl') || null;
  if (token) {
    operation.setContext({
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
};

const requestLink = new ApolloLink(
  (operation, forward) => new Observable((observer) => {
    let handle;
    Promise.resolve(operation)
      .then(oper => request(oper))
      .then(() => {
        handle = forward(operation).subscribe({
          next: observer.next.bind(observer),
          error: observer.error.bind(observer),
          complete: observer.complete.bind(observer),
        });
      })
      .catch(observer.error.bind(observer));

    return () => {
      if (handle) handle.unsubscribe();
    };
  }),
);

const httpLink = createUploadLink({ uri: process.env.VUE_APP_GRAPHQL_URL });

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([requestLink, httpLink]),
});

export default new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $query: {
      notifyOnNetworkStatusChange: true,
      loadingKey: 'loading',
    },
  },
});
